var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Doughnut',{attrs:{"options":_vm.chartOptions,"data":_vm.chartData,"id":"chartId"}})
}
var staticRenderFns = []

export { render, staticRenderFns }